import NavItem from "./NavItem";
import "../styles/Navbar.css";
import NavItemOption from "interfaces/NavItemOption";
import { useHistory } from "react-router";
import { checkIfNavItemIsActive } from "shared/utility/RouteUtility";

interface Props {
  items: NavItemOption[];
}

export default function Navbar(props: Props) {
  const history = useHistory();

  return (
    <div className="navigation-menu flex gap-x-6">
      {props.items.map((item) => {
        return (
          <NavItem
            text={item.text}
            route={item.route}
            itemId={item.itemId}
            children={item.children ?? []}
            isActive={checkIfNavItemIsActive(history.location.pathname, item)}
            key={item.itemId}
          />
        );
      })}
    </div>
  );
}
